import { useQuery } from '@tanstack/react-query';
import { useParams } from '@tanstack/react-router';
import { pcmpAccountsBatchReportQueryOptions } from '../api/pcmpAccounts.api';
import { PcmpBatchPrintView } from '../components/PcmpBatchReport/PcmpBatchPrintView';

export function PcmpAccountsBatchPrintPage() {
  const { batchNo } = useParams({ from: '/_print/pcmp/accounts/batches/$batchNo/print' });
  const { data, isLoading, isFetching, error, refetch } = useQuery({
    ...pcmpAccountsBatchReportQueryOptions(batchNo),
    // Closing the print dialog refocuses the tab; keep the sheet as printed.
    refetchOnWindowFocus: false,
  });

  return (
    <PcmpBatchPrintView
      batchNo={batchNo}
      report={data}
      isLoading={isLoading}
      isFetching={isFetching}
      error={error}
      refetch={() => void refetch()}
      documentTitle={`CMP Accounts Disbursement Batch ${batchNo}`}
    />
  );
}
